import {
  InvoiceType,
  InvoiceType as T,
} from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/enums/invoice-type.enum';

interface GenericInvoiceType {
  name: string;
  color: string;
}

export const InvoiceTypeEnum: Record<InvoiceType, GenericInvoiceType> = {
  ENERGY_CONSUMPTION: {
    name: 'ENERGY_CONSUMPTION',
    color: 'bg-surface-brand-secondary',
  },
  SYSTEM_USAGE: {
    name: 'SYSTEM_USAGE',
    color: 'bg-surface-secondary',
  },
  EMSP_CHARGING_SESSIONS: {
    name: 'EMSP_CHARGING_SESSIONS',
    color: 'bg-surface-success',
  },
  EMSP_RFID_BADGE_ORDER: {
    name: 'EMSP_RFID_BADGE_ORDER',
    color: 'bg-surface-warning',
  },
};

export const mapTypeToGenericInvoiceTypes = (type: T): GenericInvoiceType => {
  return (
    InvoiceTypeEnum[type] ?? {
      name: 'UNKNOWN',
      color: 'bg-surface-brand-secondary',
    }
  );
};
